import { useFormContext } from 'react-hook-form';
import { roundNumber } from '~/modules/@shared/helpers/roundNumber';

export function useValidateAmount({ name }: { name: string }) {
  const { setValue } = useFormContext();
  const options = { shouldDirty: true };

  const isValidAmount = (value: string) => {
    const regex = /^(?!.*\..*\.)[0-9]*(\.[0-9]{0,2})?$/;
    return regex.test(value);
  };

  const handleInputChange = (event: any) => {
    const inputValue = event.target.value;

    if (isValidAmount(inputValue)) {
      setValue(name, inputValue, options);
    }
  };
  const handleInputBlur = (event: any) => {
    const inputValue = event.target.value;
    setValue(name, roundNumber({ value: inputValue, decimals: 2 }), options);
  };

  return {
    onChange: handleInputChange,
    onBlur: handleInputBlur,
  };
}
